import { render, staticRenderFns } from "./BloodSugarData.vue?vue&type=template&id=653e36df&scoped=true"
import script from "./BloodSugarData.vue?vue&type=script&lang=js"
export * from "./BloodSugarData.vue?vue&type=script&lang=js"
import style0 from "./BloodSugarData.vue?vue&type=style&index=0&id=653e36df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653e36df",
  null
  
)

export default component.exports